<template>
  <el-menu default-active="/main/goodsview" :default-openeds="['1','2','3','4']" style="min-height: 100%; overflow-x: hidden"
           background-color="rgb(48,65,86)"
           text-color="#fff" active-text-color="#dc8" router>
    <div style="height: 60px;line-height: 60px; text-align: center">
      <img src="../assets/logo.png" alt="" style="width: 20px; position: relative;top: 5px; margin-right: 5px">
      <b style="color: white">后台管理系统</b>
    </div>

    <el-submenu :collapse="true" index="1">
      <template slot="title"><i class="el-icon-user"></i>个人中心</template>
      <el-menu-item-group>
        <el-menu-item index="/main/userview">用户管理</el-menu-item>
      </el-menu-item-group>
    </el-submenu>

    <el-submenu :collapse="true" index="2">
      <template slot="title"><i class="el-icon-user"></i>代理中心</template>
      <el-menu-item-group>
        <el-menu-item index="/main/agentview">代理管理</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu :collapse="true" index="3">
      <template slot="title"><i class="el-icon-goods"></i>产品中心</template>
      <el-menu-item-group>
        <el-menu-item index="/main/goodsview">产品管理</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu :collapse="true" index="4">
      <template slot="title"><i class="el-icon-trophy"></i>订单中心</template>
      <el-menu-item-group>
        <el-menu-item index="/main/orderview">订单管理</el-menu-item>
        <el-menu-item index="/main/ordermanagerview">代理订单报表</el-menu-item>
        <el-menu-item index="/main/moneylog">提现记录</el-menu-item>
        <el-menu-item index="/main/ordercommissionview">佣金统计</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Aside'
}
</script>

<style scoped>

</style>
